import { isValidName, isValidEmail, isValidMemberId } from "@usas/ui-web/utils/validation";

export const localValidate = (formState) => {
  let errors = {};
  let filterCount = 0;

  if (formState.credentialTypeId < 0) {
    errors.credentialTypeId = 'A valid Credential is required';
  }

  if (formState.firstOrPreferredName.trim() !== '') {
    filterCount += 1;

    if (!isValidName(formState.firstOrPreferredName.trim())) {
      errors.firstOrPreferredName = 'First or Preferred Name cannot contain numbers, special characters, or exceed 100 characters';
    }
  }

  if (formState.lastName.trim() !== '') {
    filterCount += 1;

    if (!isValidName(formState.lastName.trim())) {
      errors.lastName = 'Last Name cannot contain numbers, special characters, or exceed 100 characters';
    }
  }

  if (formState.memberId.trim() !== '') {
    filterCount += 1;

    if (!isValidMemberId(formState.memberId.trim())) {
      errors.memberId = 'Member Id must be 14 alphanumeric characters';
    }
  }

  if (formState.email.trim() !== '') {
    filterCount += 1;

    if (!isValidEmail(formState.email.trim())) {
      errors.email = 'Email must be in a valid format';
    } else if (formState.email.trim().length > 512) {
      errors.email = 'Email cannot exceed 512 characters'
    }
  }

    if (filterCount === 0) {
    errors.filter = 'To search for Members with a Credential, please provide at least one of the following filters: First or Preferred Name, Last Name, Member Id, or Email.';
  }

  return errors;
};

const OrgUnitAdminCredentialsSelectionValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default OrgUnitAdminCredentialsSelectionValidation;